var exports = {
  "kL": "xa15a2ab7--8dcab2--container",
  "wx": "xa15a2ab7--8dcab2--header",
  "vK": "xa15a2ab7--8dcab2--banner",
  "DD": "xa15a2ab7--8dcab2--title",
  "VA": "xa15a2ab7--8dcab2--subtitle",
  "x6": "xa15a2ab7--8dcab2--button",
};

module.exports = exports;
